export const usercentricsCmpScriptId = 'usercentrics-cmp';
export const usercentricsAutoblockerScriptId = 'usercentrics-autoblocker';
export const usercentricsCmpSrc = 'https://web.cmp.usercentrics.eu/ui/loader.js';
export const usercentricsAutoblockerSrc = 'https://web.cmp.usercentrics.eu/modules/autoblocker.js';

// Event names
export const usercentricsInitializedEvent = 'UC_UI_INITIALIZED';
export const usercentricsConsentChangeEvent = 'onConsentUpdate';
export const usercentricsBridgeReadyEvent = 'usercentrics.consent.bridge_ready';

// Google Consent Mode defaults
export const defaultGoogleConsentState = {
  ad_storage: 'denied' as const,
  ad_user_data: 'denied' as const,
  ad_personalization: 'denied' as const,
  analytics_storage: 'denied' as const,
  functionality_storage: 'denied' as const,
  personalization_storage: 'denied' as const,
  security_storage: 'granted' as const
};

// Consent to API mapping
export const consentCategoryMapping = {
  'analytics_storage': 'Analytics',
  'marketing': 'Marketing',
  'functionality_storage': 'Functionality',
  'ad_storage': 'Advertising'
};
